import { captureService, type CaptureInfo, type CaptureSelectionPreference } from './capture-service'

type Consumer = 'statistics' | 'buffs'
const consumers = new Map<Consumer, number>()
let constraintTask = Promise.resolve()
let limited = false
let constraintSelection = captureService.selectionId
export function captureRateLimited(): boolean {
  return captureService.frameRateConstraintApplied === false || constraintSelection === captureService.selectionId && limited
}
export function hasCaptureConsumer(consumer: Consumer): boolean { return consumers.has(consumer) }
export function requestedCaptureFps(): number { return consumers.size ? Math.max(...consumers.values()) : 1 }
export function retainCapture(consumer: Consumer, fps: number): void { consumers.set(consumer, fps) }
export function syncCaptureRate(): Promise<void> {
  const selection = captureService.selectionId
  if (constraintSelection !== selection) {
    constraintSelection = selection; constraintTask = Promise.resolve(); limited = false
  }
  constraintTask = constraintTask.catch(() => undefined).then(() => {
    if (selection === captureService.selectionId) return captureService.updateFrameRate(requestedCaptureFps())
  }).then(() => { if (selection === captureService.selectionId) limited = false }, () => { if (selection === captureService.selectionId) limited = true })
  return constraintTask
}
export function releaseCapture(consumer: Consumer): void {
  if (!consumers.delete(consumer)) return
  if (!consumers.size) captureService.stop()
  else void syncCaptureRate().catch(() => undefined)
}
export function selectSharedCapture(consumer: Consumer, fps: number, preference: CaptureSelectionPreference = 'window'): Promise<CaptureInfo> {
  retainCapture(consumer, fps)
  if (captureService.mediaStream && ['active', 'selected', 'connecting'].includes(captureService.status)) {
    return syncCaptureRate().then(() => captureService.connectSelectedWindow())
  }
  // Invoke synchronously from the click to preserve browser user activation.
  return captureService.selectWindow(preference, requestedCaptureFps())
}
